/* Ezzyrol product page: variant selection over the compact list printed by sections/ez-product.liquid.
   On every option change: find the variant (exact match, else the closest one that keeps the option just
   chosen), then update the hidden id, price and its note, stock line, the buy buttons, sold out marks on
   every other option, pill prices, the figures for the chosen size, the gallery (the variant's photo moves
   to the front, or the variant's own gallery when it has one), the size table row, the sticky bar and the URL. When the chosen variant is sold out, the
   "in stock instead" panel offers the same size in other colours and the same colour in other sizes.
   Dawn's product-form element does the add to cart. assets/ez.js does the value labels, the quantity
   stepper, the single or set switch and the sticky bar's visibility. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ez-product]');
  var vEl = document.querySelector('[data-ez-variants]');
  var mEl = document.querySelector('[data-ez-product-meta]');
  if (!root || !vEl || !mEl) return;
  var variants = JSON.parse(vEl.textContent);
  var meta = JSON.parse(mEl.textContent);
  var fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var money = function (p) { return fmt.format(p / 100); };
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var isSet = function (v) { v = (v || '').toLowerCase(); return v.indexOf('set') > -1 || v.indexOf('piece') > -1; };
  var clean = function (v) { return (v || '').split('|')[0].trim(); };
  var cutoff = ($('[data-ez-stock]') || {}).getAttribute ? $('[data-ez-stock]').getAttribute('data-cutoff') : '';

  function selected() {
    return $$('[data-ez-option]').map(function (fs) {
      var i = +fs.getAttribute('data-ez-option');
      var c = fs.querySelector('input[data-ez-opt-input]:checked');
      return { i: i, v: c ? c.value : null };
    });
  }
  function find(sel, changed) {
    var exact = variants.filter(function (v) { return sel.every(function (s) { return s.v === null || v.o[s.i] === s.v; }); })[0];
    if (exact) return exact;
    var keep = sel.filter(function (s) { return s.i === changed; })[0];
    var pool = keep ? variants.filter(function (v) { return v.o[keep.i] === keep.v; }) : variants;
    var best = null, score = -1;
    pool.forEach(function (v) {
      var sc = sel.filter(function (s) { return v.o[s.i] === s.v; }).length + (v.a ? 0.5 : 0);
      if (sc > score) { score = sc; best = v; }
    });
    return best || variants[0];
  }

  function check(i, value) {
    var inp = $$('[data-ez-option="' + i + '"] input[data-ez-opt-input]').filter(function (x) { return x.value === value; })[0];
    if (inp) inp.checked = true;
  }

  function render(v, first) {
    // selections follow the variant (a fallback may have changed another option)
    v.o.forEach(function (val, i) { check(i, val); });
    $$('[data-ez-option]').forEach(function (fs) {
      var i = +fs.getAttribute('data-ez-option');
      var out = fs.querySelector('[data-ez-val]'); if (out) out.textContent = clean(v.o[i]);
      // sold out marks and prices, given the other current selections
      fs.querySelectorAll('input[data-ez-opt-input]').forEach(function (inp) {
        var others = variants.filter(function (x) {
          return x.o[i] === inp.value && x.o.every(function (ov, j) { return j === i || ov === v.o[j]; });
        });
        var match = others[0];
        var anyAvail = others.some(function (x) { return x.a; });
        var label = inp.closest('.ez-swatch, .ez-pill');
        if (!label) return;
        var soldCls = label.classList.contains('ez-swatch') ? 'ez-swatch--soldout' : 'ez-pill--soldout';
        label.classList.toggle(soldCls, !anyAvail);
        var pr = label.querySelector('[data-ez-pill-price]');
        if (pr) {
          var price = match ? match.p : Math.min.apply(null, variants.filter(function (x) { return x.o[i] === inp.value; }).map(function (x) { return x.p; }));
          pr.textContent = anyAvail ? money(price) : 'Sold out';
          var b = label.querySelector('b');
          inp.setAttribute('aria-label', (b ? b.textContent : inp.value) + ', ' + (anyAvail ? money(price) : 'sold out'));
        }
        if (label.classList.contains('ez-swatch')) {
          var nm = inp.value + (anyAvail ? '' : ', sold out');
          label.title = nm; var vh = label.querySelector('.ez-vh'); if (vh) vh.textContent = nm;
        }
      });
    });
    // single or set: show the group holding the chosen value; seg prices for the chosen colour
    if (meta.size > -1) {
      var mode = isSet(v.o[meta.size]) ? 'set' : 'single';
      $$('[data-ez-mode]').forEach(function (g) { g.hidden = g.getAttribute('data-ez-mode') !== mode; });
      $$('[data-ez-seg]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ez-seg') === mode ? 'true' : 'false'); });
      ['single', 'set'].forEach(function (m) {
        var el = $('[data-ez-seg-price="' + m + '"]'); if (!el) return;
        var ps = variants.filter(function (x) { return (meta.colour < 0 || x.o[meta.colour] === v.o[meta.colour]) && (isSet(x.o[meta.size]) === (m === 'set')); }).map(function (x) { return x.p; });
        if (ps.length) el.textContent = 'from ' + money(Math.min.apply(null, ps));
      });
    }
    // price and its note
    $('[data-ez-price]').textContent = money(v.p);
    var note = $('[data-ez-price-note]');
    if (note && meta.size > -1 && variants.some(function (x) { return x.p !== v.p; })) note.textContent = 'Price for the ' + clean(v.o[meta.size]) + ', including VAT. Free UK delivery.';
    // buy buttons
    var id = $('[data-ez-variant-id]'); id.value = v.id;
    var atc = $('[data-ez-atc]'), lab = $('[data-ez-atc-label]');
    atc.disabled = !v.a; if (v.a) atc.removeAttribute('aria-disabled'); else atc.setAttribute('aria-disabled', 'true');
    lab.textContent = v.a ? 'Add to cart' : 'Sold out';
    var dyn = $('[data-ez-dyn]'); if (dyn) dyn.hidden = !v.a;
    // stock line
    var st = $('[data-ez-stock]'), stt = $('[data-ez-stock-text]');
    st.classList.toggle('ez-stock--out', !v.a);
    stt.textContent = v.a ? ((v.low ? 'Only ' + v.low + ' left.' : 'In stock.') + ' ' + cutoff + '.') : 'Sold out in ' + v.t.toLowerCase() + '.';
    instead(v);
    // figures for the chosen size
    $$('[data-ez-figs-for]').forEach(function (f) { f.hidden = meta.size < 0 || f.getAttribute('data-ez-figs-for') !== v.o[meta.size]; });
    document.querySelectorAll('[data-ez-size-row]').forEach(function (r) { r.classList.toggle('ez-table__row--current', meta.size > -1 && r.getAttribute('data-ez-size-row') === v.o[meta.size]); });
    // gallery: the variant's own photos (v.g, its Amazon listing's images in order) or, without them, its photo first
    if (!first) showGallery(v);
    // sticky bar
    var sp = document.querySelector('[data-ez-sticky-price]'); if (sp) sp.textContent = money(v.p);
    var stl = document.querySelector('[data-ez-sticky-title]'); if (stl && variants.length > 1) stl.textContent = v.t;
    var sb = document.querySelector('[data-ez-sticky-atc]'); if (sb) { sb.disabled = !v.a; sb.textContent = v.a ? 'Add to cart' : 'Sold out'; }
    // the thumbnail follows the variant: copy its main photo from the gallery, at thumbnail width
    var st = document.querySelector('[data-ez-sticky-img]'), sid = v.m || (v.g && v.g[0]);
    var sim = sid && document.querySelector('.ez-gal__item[data-media-id="' + sid + '"] img');
    if (st && sim && sim.getAttribute('src')) {
      try { var su = new URL(sim.getAttribute('src'), location.href); su.searchParams.set('width', '120'); st.removeAttribute('srcset'); st.src = su.toString(); } catch (e) {}
    }
    // address
    if (!first) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    }
  }

  // Show one variant's gallery. With v.g: exactly those photos, in that order, everything else hidden. Without: every
  // photo, the variant's own one first. The big first slot, the "1 / n" badge and "Show all" follow what is shown.
  function showGallery(v) {
    var gal = $('[data-ez-gal]'); if (!gal) return;
    var items = $$('.ez-gal__item[data-media-id]', gal);
    var byId = {}; items.forEach(function (f) { byId[f.getAttribute('data-media-id')] = f; });
    var order = (v.g && v.g.length) ? v.g.map(String).filter(function (id) { return byId[id]; }) : [];
    var btn = gal.querySelector('[data-ez-gal-all]');
    if (order.length) {
      // build the order apart, then place it first in one move (the current first photo may itself be in the list)
      var frag = document.createDocumentFragment();
      order.forEach(function (id) { frag.appendChild(byId[id]); });
      gal.insertBefore(frag, gal.firstElementChild);
      items.forEach(function (f) { f.hidden = order.indexOf(f.getAttribute('data-media-id')) < 0; });
    } else {
      items.forEach(function (f) { f.hidden = false; });
      if (v.m && byId[v.m]) gal.insertBefore(byId[v.m], gal.firstElementChild);
    }
    if (btn) gal.appendChild(btn);
    var shown = $$('.ez-gal__item[data-media-id]:not([hidden])', gal);
    shown.forEach(function (f, i) {
      f.classList.toggle('ez-gal__item--extra', i > 6);
      var img = f.querySelector('img');
      if (img && i === 0) { img.loading = 'eager'; img.sizes = '(min-width: 990px) 55vw, 82vw'; }
      else if (img) img.sizes = '(min-width: 990px) 27vw, 82vw';
    });
    gal.removeAttribute('data-all');
    var count = gal.querySelector('.ez-gal__count');
    if (count && shown[0]) {
      shown[0].appendChild(count); count.hidden = shown.length < 2;
      var n = count.querySelector('[data-ez-gal-n]'); if (n) n.textContent = shown.length;
      var ci = count.querySelector('[data-ez-gal-i]'); if (ci) ci.textContent = 1;
    }
    if (btn) { btn.hidden = shown.length <= 7; var bn = btn.querySelector('[data-ez-gal-all-n]'); if (bn) bn.textContent = shown.length; }
    gal.scrollTo({ left: 0, behavior: 'smooth' });
  }

  // what is in stock instead of a sold out choice: never a dead end
  function instead(v) {
    var box = $('[data-ez-instock]'); if (!box) return;
    if (v.a) { box.hidden = true; box.innerHTML = ''; return; }
    var html = '<p class="ez-instock__h">In stock instead</p>';
    var c = meta.colour, s = meta.size;
    var grp = function (k, list, lab) {
      if (!list.length) return '';
      return '<div class="ez-instock__grp"><p class="ez-instock__k">' + k + '</p><nav class="ez-chips ez-instock__chips" style="--n-sm:2;--n:4" aria-label="' + lab + '">' +
        list.map(function (x) { return '<a class="ez-chip" href="' + meta.url + '?variant=' + x.v.id + '">' + x.t + '</a>'; }).join('') + '</nav></div>';
    };
    if (c > -1) {
      var sameSize = variants.filter(function (x) { return x.a && x.o.every(function (ov, j) { return j === c || ov === v.o[j]; }); });
      html += grp(s > -1 ? 'The same ' + clean(v.o[s]) + ', in' : 'The same, in', sameSize.map(function (x) { return { v: x, t: x.o[c] }; }), 'Other colours in stock');
    }
    if (s > -1) {
      var sameCol = variants.filter(function (x) { return x.a && x.o.every(function (ov, j) { return j === s || ov === v.o[j]; }); });
      html += grp((c > -1 ? v.o[c] + ', in' : 'In') + ' another size', sameCol.map(function (x) { return { v: x, t: clean(x.o[s]) + ', ' + money(x.p) }; }), 'Other sizes in stock');
    }
    html += '<a class="ez-link ez-link--quiet" href="/pages/contact">Ask us when it is back</a>';
    box.innerHTML = html; box.hidden = false;
  }

  root.addEventListener('change', function (e) {
    var t = e.target; if (!t.matches('input[data-ez-opt-input]')) return;
    var fs = t.closest('[data-ez-option]');
    render(find(selected(), +fs.getAttribute('data-ez-option')));
  });
  // single or set switch: jump to the cheapest in-stock variant of that kind in the same colour
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-ez-seg]'); if (!b || meta.size < 0) return;
    var want = b.getAttribute('data-ez-seg') === 'set';
    var cur = find(selected(), -1);
    var pool = variants.filter(function (x) { return isSet(x.o[meta.size]) === want && (meta.colour < 0 || x.o[meta.colour] === cur.o[meta.colour]); });
    if (!pool.length) pool = variants.filter(function (x) { return isSet(x.o[meta.size]) === want; });
    pool.sort(function (a, b2) { return (b2.a - a.a) || (a.p - b2.p); });
    if (pool[0]) render(pool[0]);
  });
  var all = $('[data-ez-gal-all]');
  if (all) all.addEventListener('click', function () { var g = $('[data-ez-gal]'); g.setAttribute('data-all', ''); all.hidden = true; var x = g.querySelector('.ez-gal__item--extra:not([hidden])'); if (x) { x.tabIndex = -1; x.focus({ preventScroll: true }); } });
  // gallery position on phones ("3 / 8")
  var gal = $('[data-ez-gal]'), gi = $('[data-ez-gal-i]');
  if (gal && gi) gal.addEventListener('scroll', function () {
    var w = gal.firstElementChild ? gal.firstElementChild.getBoundingClientRect().width + 8 : 1;
    gi.textContent = Math.min(gal.querySelectorAll('.ez-gal__item:not([hidden])').length, Math.round(gal.scrollLeft / w) + 1);
  }, { passive: true });

  // first paint: marks for the variant the server chose (it may be sold out)
  var start = variants.filter(function (x) { return String(x.id) === ($('[data-ez-variant-id]') || {}).value; })[0];
  if (start && variants.length > 1) render(start, true);
})();
